
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { CRMActions } from "./crm/CRMActions";
import { CRMFilters } from "./crm/CRMFilters";
import { CRMTableSection } from "./crm/CRMTableSection";
import { useCRMData } from "./crm/useCRMData";

export const CRMTab = () => {
  const {
    filteredData,
    allFilteredData,
    crmData,
    isLoading,
    error,
    sortConfig,
    filters,
    showFilters,
    currentPage,
    totalPages,
    goToPage,
    nextPage,
    prevPage,
    setFilters,
    setShowFilters,
    sortData,
    downloadExcel,
    exportExcel
  } = useCRMData();

  // Extract membership IDs from filtered data for CERFA ZIP export
  const filteredMembershipIds = allFilteredData
    .filter(item => item.type_adhesion && item.lien_cerfa)
    .map(item => item.id);

  const toggleFilter = () => {
    setShowFilters(!showFilters);
  };

  const handleSearchChange = (value: string) => {
    setFilters(prev => ({ ...prev, searchTerm: value }));
  };

  const handleStartDateChange = (date: Date | undefined) => {
    setFilters(prev => ({ ...prev, startDate: date }));
  };

  const handleEndDateChange = (date: Date | undefined) => {
    setFilters(prev => ({ ...prev, endDate: date }));
  };

  const handleDateFieldChange = (field: string) => {
    setFilters(prev => ({ ...prev, dateField: field }));
  };

  return (
    <Card>
      <CardHeader className="flex flex-row items-center justify-between">
        <div>
          <CardTitle>Base de données CRM</CardTitle>
          <CardDescription>Liste unifiée des membres, signataires et abonnés newsletter</CardDescription>
        </div>
        <CRMActions 
          onToggleFilter={toggleFilter} 
          onDownload={downloadExcel}
          onExportExcel={exportExcel}
          showFilters={showFilters}
          filteredMembershipIds={filteredMembershipIds}
        />
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          <CRMFilters
            filters={filters}
            setFilters={setFilters}
            showFilters={showFilters}
            crmDataLength={crmData.length}
            filteredDataLength={filteredData.length}
            handleSearchChange={handleSearchChange}
            handleStartDateChange={handleStartDateChange}
            handleEndDateChange={handleEndDateChange}
            handleDateFieldChange={handleDateFieldChange}
          />
          
          <CRMTableSection
            isLoading={isLoading}
            error={error}
            filteredData={filteredData}
            sortConfig={sortConfig}
            onSort={sortData}
            currentPage={currentPage}
            totalPages={totalPages}
            goToPage={goToPage}
            nextPage={nextPage}
            prevPage={prevPage}
          />
        </div>
      </CardContent>
    </Card>
  );
};
